import { render } from "./IconTranscoder.vue?vue&type=template&id=45e9f728"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconTranscoder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45e9f728"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45e9f728', __exports__)) {
    api.reload('45e9f728', __exports__)
  }
  
  module.hot.accept("./IconTranscoder.vue?vue&type=template&id=45e9f728", () => {
    api.rerender('45e9f728', render)
  })

}


export default __exports__